export const ROLES_CONFIG = {
    customer: 3,
    admin: 1
};

